import StepSwitch from './StepSwitch';

export default StepSwitch;
